import store from '../../store/configure-store';


/**
 * customizationParser
 * 
 * @param {string} login 
 * @returns 
 */
export const customizationParser = () => {
  const { login } = store.getState('login');
  const customization = login?.customization;

  if (!customization) return null;

  if (typeof customization === 'string') {
    try {
      return JSON.parse(customization);
    } catch (e) {
      console.error('COULD NOT parse config', e);
      return null;
    }
  }

  return customization;
};

export const getCurrencyNumberOfDigits = () => {
  const { login } = store.getState('login');

  // Novi snake_case field sa BE-a (prioritet)
  const fromPlayerData = login?.player_data?.currency_number_of_digits;
  if (fromPlayerData != null) return Number(fromPlayerData);

  // Top-level fallback (ako BE pošalje direktno na login objektu)
  const topLevel = login?.currency_number_of_digits;
  if (topLevel != null) return Number(topLevel);

  // Legacy PascalCase field
  return login?.CurrencyNumberOfDigits;
}
